export function decodeFilename(base64: string) {
    const binString = atob(base64)

    const bytes = Uint8Array.from(binString, (m) => m.charCodeAt(0))

    return new TextDecoder().decode(bytes)
}
